/** Todo emoji do chat é o da Apple: o texto é partido e cada emoji vira <em-emoji>. */
import React from "react";

import { EmojiApple } from "./Emojis";

const EMOJI = "(\\p{Extended_Pictographic}(?:\\uFE0F|\\u200D\\p{Extended_Pictographic}|[\\u{1F3FB}-\\u{1F3FF}])*|[\\u{1F1E6}-\\u{1F1FF}]{2})";
const MENCAO = "(@[\\wÀ-ÿ.-]+)";
const SO_EMOJI = new RegExp(`^${EMOJI}$`, "u");
const SO_MENCAO = new RegExp(`^${MENCAO}$`, "u");

export function partirTexto(texto, mencoes = true) {
  const divisor = new RegExp(`${EMOJI}|${mencoes ? MENCAO : "(?!)"}`, "gu");
  return String(texto || "").split(divisor).filter((p) => p !== undefined && p !== "");
}

export function TextoComEmojis({ texto, mencoes = true }) {
  return (
    <>
      {partirTexto(texto, mencoes).map((parte, i) =>
        SO_EMOJI.test(parte) ? (
          <EmojiApple key={i} native={parte} size="1.15em" />
        ) : mencoes && SO_MENCAO.test(parte) ? (
          <span key={i} className="mencao">{parte}</span>
        ) : (
          <span key={i}>{parte}</span>
        ),
      )}
    </>
  );
}
